<template>
  <span :class="badgeClass">
    <slot />
  </span>
</template>

<script lang="ts" setup>
type BadgeVariant = 'success' | 'info' | 'warning' | 'error' | 'neutral';

const props = defineProps<{
  variant?: BadgeVariant;
}>();

const badgeClass = computed(() =>
  props.variant ? `badge-${props.variant}` : 'badge'
);
</script>
